import AspectRatio from "../../../AspectRatio";

const YoutubePlayer = ({ videoUrl }) => {
  // Verificar si la URL es de YouTube
  const isYoutubeUrl = (url) => {
    return url?.includes("youtube.com") || url?.includes("youtu.be");
  };

  // Extraer el ID del video de la URL
  const getVideoId = (url) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url?.match(regex);
    return match ? match[1] : null;
  };

  // Renderizar el reproductor de YouTube si es una URL válida de YouTube
  if (isYoutubeUrl(videoUrl)) {
    const videoId = getVideoId(videoUrl);
    return (
      <AspectRatio
        ratio="16/9"
        maxWidth={940}
        key={`attached-file-${videoUrl}`}
      >
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ border: 0, maxWidth: "100%" }}
        />
      </AspectRatio>
    );
  } else {
    return <p>No es una URL válida de YouTube</p>;
  }
};

export default YoutubePlayer;
